module.exports = __webpack_public_path__ + "img/Insurance.6fafe410.svg";